<script setup lang="ts">
import { onMounted, nextTick } from 'vue';
import useAppStore from '@/store/app.store';

const appStore = useAppStore();

onMounted(() => {
  // 初始化主题色
  document.documentElement.style.setProperty('--el-color-primary', appStore.themeColor);
});
</script>

<template>
  <router-view />
</template>
